import { Pipe, PipeTransform } from '@angular/core';

/** Qué disparó una orden en /broker (tbl_orden.origen). Sin valor: otro flujo u orden histórica. */
export type OrigenOrden = 'SINCRONIZAR' | 'FORZAR_ENTRADAS' | 'AUTOMATIZAR' | 'SALIDA_FIN_DIA'
  | 'ENTRADA_MANUAL' | 'SALIDA_MANUAL' | 'SL_MANUAL' | 'TP_MANUAL';

const ETIQUETAS_ORIGEN: Record<OrigenOrden, string> = {
  SINCRONIZAR: 'Sincronizar',
  FORZAR_ENTRADAS: 'Forzar entradas',
  AUTOMATIZAR: 'Automatizar',
  SALIDA_FIN_DIA: 'Salida fin de día',
  ENTRADA_MANUAL: 'Entrada manual',
  SALIDA_MANUAL: 'Salida manual',
  SL_MANUAL: 'SL manual',
  TP_MANUAL: 'TP manual',
};

export function etiquetaOrigenOrden(origen: string | null | undefined): string {
  return ETIQUETAS_ORIGEN[origen as OrigenOrden] ?? origen ?? '—';
}

@Pipe({ name: 'origenOrden' })
export class OrigenOrdenPipe implements PipeTransform {
  transform(origen: string | null | undefined): string {
    return etiquetaOrigenOrden(origen);
  }
}
